export default class PassengerCategory {
  id: number
  name: string
  code: string
  description?: string
  created: string
  type: TypePassenger

  constructor(props: PassengerCategory) {
    Object.assign(this, props)
  }
}

export const TypePassenger = {
  Adult: 'adult',
  Senior: 'senior',
  Child: 'child',
  Infant: 'infant',
  Student: 'student',
  Handicapped: 'handicapped',
  Military: 'military'
}

export type TypePassenger = string



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/PassengerCategories/Model.ts